export enum IVRResponseDirection {
  sent = 'sent',
  received = 'received',
}
